import { render, staticRenderFns } from "./TabCollection.vue?vue&type=template&id=86f2af5a&scoped=true"
import script from "./TabCollection.vue?vue&type=script&lang=js"
export * from "./TabCollection.vue?vue&type=script&lang=js"
import style0 from "./TabCollection.vue?vue&type=style&index=0&id=86f2af5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f2af5a",
  null
  
)

export default component.exports